import { Box, Skeleton, Tbody } from "@chakra-ui/react";
import { ReactNode, useContext, useRef } from "react";

import { RanaLoading } from "../../components/rana-loading";
import { NetworkContext } from "../../stores/network-provider";
import { TableContext } from "../rana-table";

import { TableEmpty } from "./table-empty";
import { TABLE_ROW_HEIGHT } from "./table-row";

export function TableBody({ children }: { children: ReactNode }) {
  const { isSkeleton } = useContext(TableContext);
  const tableContentRef = useRef<HTMLDivElement>(null);

  return (
    <Tbody as={isSkeleton ? Box : undefined} ref={tableContentRef} bg="brand.bg">
      <TableBodyInner>{children}</TableBodyInner>
    </Tbody>
  );
}

export const TableBodyInner = ({ children }: { children: ReactNode }) => {
  const { isOnline } = useContext(NetworkContext);
  const { isLoading, isSkeleton, emptyElement, isEmpty } = useContext(TableContext);

  if (!isOnline) {
    return <TableEmpty.Offline />;
  }

  if (isSkeleton) {
    const SKELETON_GAP = "1px" as string;
    return Array(10)
      .fill("")
      .map((_, idx) => (
        <Skeleton key={idx} h={`calc(${TABLE_ROW_HEIGHT} - ${SKELETON_GAP})`} mt={SKELETON_GAP} />
      ));
  }

  if (isLoading) {
    return (
      <TableEmpty>
        <RanaLoading boxSize={16} />
      </TableEmpty>
    );
  }

  if (isEmpty) {
    return emptyElement;
  }

  return children;
};
